const Resources = {

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Buildings',
            href:   '/buildings',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Room Types',
            href:   '/building-room-types',
            arrow:  " ",
        },
    ],

    table_headers: [
        { 
            text: 'Room Type Name',  
            align: 'start', 
            value: 'description',
            sort_type: 'text',
        },
        {   
            text: 'Floor',
            value: 'floor',
            sort_type: 'text',
        },
        {   
            text: 'Group 2',
            value: 'housekeeper',
            type: 'boolean',
            sort_type: 'boolean',
        },
        { 
            text: 'Unit',       
            value: 'unit',
            sort_type: 'number',
        },
        {
            text: 'Room Counter',
            value: 'room_counter',
            type: 'text_link_action',
            sort_type: 'number'
        },
        {   
            text:   'Daily Task(s)',
            value:  'daily_tasks',
            type:   'tasks',
        },
        {   
            text:   'Policing Task(s)',
            value:  'policing_tasks',
            type:   'tasks',
            class:  'header-blu',
        },
        {   
            text:   'Project Task(s)',
            value:  'project_tasks',
            type:   'tasks',
            class:  'header-orange',
        },
    ],

    task_table_headers: [
        { 
            name:   'Select',
        },
        {   
            name:   'Cleaning Code',
        },
        { 
            name:   'Name',
        },
        { 
            name:   'Frequency',
        },
        { 
            name:   'Order',
        },
    ],

    excel_file_headers: {
        'Room Type name': 'description',
        'What appears in the Room Description': 'abbreviation',
        'Floor Type': 'floor_id',
        'Unit': 'unit',
        'Patient' : 'patient',
        'Housekeeper II' : 'housekeeper',
        'Vacant Bed Adjustment' : 'vacant_bed_adjustment_id',
        'Daily Task'    : 'daily_task',
        'Daily Frequency' : 'daily_frequency',
        'Order Daily'    : 'order_daily',
        'Policing Task'   : 'policing_task',
        'Policing Frequency' : 'policing_frequency',
        'Order Policing'    : 'order_policing',
    },
    

    excel_file_task_headers: {
        'Room Type': 'Room Type',
        'Task': 'Task',
        'Frecuency': 'Frecuency',
        'Order': 'Order'
    },


    excel_fields_required: {
        description: true,
        abbreviation: true,
        floor_id: true,
        unit: true,
        patient: false,
        housekeeper: false,
        vacant_bed_adjustment_id: false,
        daily_task: false,
        daily_frequency: false,
        order_daily: false,
        policing_task: false,
        policing_frequency: false,
        order_policing: ''
    },

    empty_format_data: [
        {
            description: '',
            abbreviation: '',
            floor_id: '',
            unit: 1,
            patient: false,
            housekeeper: false,
            daily_task: '',
            daily_frequency: 7,
            order_daily: '',
            policing_task: '',
            policing_frequency: 7,
            order_policing: ''
        },
    ],

    task_empty_format_data: 
    [
        {
            'Room Type': '',
            'Task': '',
            'Frecuency': 7,
            'Order': ''
        },
    ],

    tabs:[
        {
            name: 'Daily tasks',
            href_child_tab: '#daily',
            href_child_tab_update: '#daily-update',
        },
        {
            name: 'Policing tasks',
            href_child_tab: '#policing',
            href_child_tab_update: '#policing-update',
        },
    ],

    helps: [
        {
            label: '¿How to add a Room Type?', 
            instruction: `https://scribehow.com/embed/Add_a_Room_Type__YXWflm7aSGeUj5AHd8brKg?as=scrollable`
        },
        {
            label: '¿How to delete Room Types?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Room_Types__6c_pNV8uQTaAskLDp0fSsA?as=scrollable`
        },
    ]

}

export default Resources